/**
 * Check if user has valid authentication cookies.
 * These are not the actual session cookies, but reference cookies with the same expiration.
 * Returns true if either tv-session-active or tv-remember-me-active exists.
 */
export const checkAuthCookies = (): boolean => {
  if (typeof document === 'undefined') {
    // Server-side or non-browser environment
    return false;
  }

  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());

  const hasSessionCookie = cookies.some((cookie) => cookie.startsWith('tv-session-active='));
  const hasRememberMeCookie = cookies.some((cookie) => cookie.startsWith('tv-remember-me-active='));

  return hasSessionCookie || hasRememberMeCookie;
};
